import Grid from "@mui/material/Grid";
import React, { useRef, useEffect, useState } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useMsal } from "@azure/msal-react";
import sharpwatchLogo from "assets/images/Sharpwatch_Banner_white.png";

function Home() {
  const iframeRef = useRef(null);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userRoles = activeAccount?.idTokenClaims?.roles || [];

  const [selectedRole, setSelectedRole] = useState(
    localStorage.getItem("selectedRole") || userRoles[0] || ""
  );

  useEffect(() => {
    const storedRole = localStorage.getItem("selectedRole");
    if (storedRole && selectedRole !== storedRole) {
      setSelectedRole(storedRole);
    }
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Logo Section */}
      <MDBox
        bgColor="rgba(148, 148, 148, 0.07)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius="lg"
        sx={{
          width: "100%",
          maxWidth: {
            xs: "90%",
            sm: "70%",
            md: "50%",
            xl: "900px",
            xxl: "1000px",
          },
          mx: "auto",
          mt: 2,
          px: 2,
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.36)",
          backdropFilter: "blur(8px)",
        }}
      >
        <img
          src={sharpwatchLogo}
          alt="SharpWatch Logo"
          style={{
            width: "100%",
            maxHeight: "120px",
            objectFit: "contain",
          }}
        />
      </MDBox>

      {/* Video Section */}
      <MDBox
        bgColor="rgba(148, 148, 148, 0.07)"
        borderRadius="lg"
        p={2}
        mt={1}
        mb={1}
        mx="auto"
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          width: "100%",
          maxWidth: {
            xs: "100%",
            sm: "95%",
            md: "90%",
            xl: "1300px",
            xxl: "1500px",
          },
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.36)",
          backdropFilter: "blur(8px)",
          overflow: "hidden",
        }}
      >
        <MDBox
          sx={{
            width: "100%",
            px: { xs: 0, sm: 2 },
            borderRadius: "12px",
            overflow: "hidden",
            maxHeight: { xs: "auto", md: "500px", xl: "560px" },
          }}
        >
          <video
            width="100%"
            height="auto"
            controls
            autoPlay
            playsInline
            controlsList="nodownload"
            style={{
              display: "block",
              backgroundColor: "black",
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
              border: "none",
              objectFit: "contain",
              maxHeight: "560px",
            }}
          >
            <source
              src="https://teslasubsea.com/wp-content/uploads/2025/03/SHARPWATCH-INTRO-1080p.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Home;
